<mat-card class="information-network-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">settings_ethernet</mat-icon>
    </div>
    <mat-card-title>Network</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <mat-list>
      <mat-list-item>

        <mat-icon mat-list-icon>settings_input_component</mat-icon>
        <div mat-line> Ipaddr: {{ information.ip_address}}</div>

      </mat-list-item>
      <mat-list-item>
        <mat-icon mat-list-icon>settings_input_component</mat-icon>

        <div mat-line> Netmask: {{ information.ip_mask }} </div>
      </mat-list-item>
      <mat-list-item>
        <mat-icon mat-list-icon>computer</mat-icon>
        <div mat-line> Mac: {{ information.HWaddr}}</div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>

